function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { Fragment, useContext } from "react";
import { useStyle } from "./Skeleton.style";
import { CarinaContext } from "../CarinaProvider/index";
export var BORDER_RADIUS = [
    'none',
    'twoX',
    'threeX',
    'fiveX',
    'round'
];
var Skeleton = function(_param) {
    var ariaValueText = _param['aria-valuetext'], borderRadius = _param.borderRadius, children = _param.children, hasPulse = _param.hasPulse, hasShimmer = _param.hasShimmer, height = _param.height, isFilled = _param.isFilled, isRtl = _param.isRtl, _lines = _param.lines, lines = _lines === void 0 ? 1 : _lines, width = _param.width, rest = _objectWithoutProperties(_param, [
        'aria-valuetext',
        "borderRadius",
        "children",
        "hasPulse",
        "hasShimmer",
        "height",
        "isFilled",
        "isRtl",
        "lines",
        "width"
    ]);
    var ref;
    var prefersReducedMotion = ((ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {
        prefersReducedMotion: false
    }).prefersReducedMotion;
    var skeleton = useStyle({
        borderRadius: borderRadius,
        hasChildren: !!children,
        hasPulse: prefersReducedMotion && hasShimmer ? true : hasPulse,
        hasShimmer: prefersReducedMotion ? false : hasShimmer,
        height: height,
        isFilled: isFilled,
        isRtl: isRtl,
        width: width
    }).skeleton;
    var role = ariaValueText ? 'progressbar' : undefined;
    if (children) {
        return _jsx("span", _objectSpread({
            css: skeleton,
            role: role
        }, rest, {
            children: children
        }));
    }
    var elements = [];
    for(var i = 0; i < lines; i += 1){
        if (lines !== 1 && i + 1 > lines && lines % 1 > 0) {
            var lastSkeleton = _objectSpread({}, skeleton, {
                width: "calc(".concat(skeleton.width, " * ").concat(lines % 1, ")")
            });
            elements.push(_jsx("span", _objectSpread({
                css: lastSkeleton
            }, rest), i));
        } else {
            elements.push(_jsx("span", _objectSpread({
                css: skeleton,
                role: i === 0 ? role : undefined
            }, rest), i));
        }
        if (lines !== 1 && i + 1 < lines) {
            elements.push(_jsx("br", {}, "".concat(i, "_br")));
        }
    }
    return _jsx(Fragment, {
        children: elements
    });
};
export { Skeleton };
export default Skeleton;
